<template>
  <div class="confirm-email-wrapper">
    <v-alert
      class="rounded-lg pointer mb-0"
      type="error"
      outlined
      dense
      @click="requestConfirmEmail()"
    >
      <div class="text-body-2 mb-n1">Seu e-mail ainda não foi confirmado.</div>
      <div class="text-caption">
        Clique aqui para confirmar e validar sua conta.
      </div>
    </v-alert>

    <CustomDialog
      v-model="confirmDialog"
      ref="customDialog"
      title="Confirmação de e-mail"
      :hideFooter="loading.request"
      :loading="loading.confirmation"
      @cancel="confirmDialog = false"
      @submit="confirmEmail()"
    >
      <loader v-if="loading.request" />

      <v-form
        v-else
        v-model="valid"
        ref="form"
        class="form"
        autocomplete="off"
        :disabled="loading.confirmation"
      >
        <div class="mb-4" @keypress.enter.prevent="submit()">
          <div class="text-body-2 neutral8--text mb-4">
            Enviamos um código de confirmação para o
            <span class="font-italic text-decoration-underline">{{
              _user.email
            }}</span
            >. Verifique sua caixa de entrada ou a pasta de spam.
          </div>

          <div class="text-body-2 neutral8--text mb-4">
            Caso tenha informado um endereço de e-mail inválido ou errado,
            <span class="primary--text pointer" @click="changeEmail()"
              >Clique aqui</span
            >
            para trocar.
          </div>

          <div class="form-label">Digite o código de confirmação</div>

          <v-text-field
            v-model="form.code"
            class="form-input"
            label="Código de confirmação"
            :rules="_rules"
            solo
            @keydown.space.prevent
          />

          <div class="text-center text-body-2">
            <template v-if="resendCountdown > 0">
              Aguarde
              <strong>{{ resendCountdown }}</strong> segundos para reenviar o
              e-mail
            </template>

            <template v-else>
              Não recebeu o e-mail?
              <span class="primary--text pointer" @click="resendCode">
                Reenviar código
              </span>
            </template>
          </div>
        </div>
      </v-form>
    </CustomDialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { requestConfirmEmail, confirmEmail } from "@/services/auth";
import { validations } from "@/helpers";
import CustomDialog from "@/components/customDialog/CustomDialog";

export default {
  name: "ConfirmEmail",

  components: {
    CustomDialog,
  },

  data() {
    return {
      loading: {
        request: false,
        confirmation: false,
      },
      confirmDialog: false,
      valid: false,
      form: {
        code: "",
      },
      resendCountdown: 0,
      resendInterval: null,
    };
  },

  computed: {
    ...mapGetters({ _user: "user" }),

    _rules() {
      return [validations.required];
    },
  },

  methods: {
    async requestConfirmEmail() {
      try {
        this.loading.request = true;
        this.confirmDialog = true;

        const payload = {
          email: this._user.email,
        };

        await requestConfirmEmail(payload);

        this.$alert("Solicitação enviada com sucesso", "success", {
          subtitle:
            "Um e-mail com código de confirmação foi enviado para a caixa de entrada do seu e-mail",
        });

        this.startResendCountdown();
      } catch (error) {
        this.$alert(error?.message, "error");
      } finally {
        this.loading.request = false;
      }
    },

    async resendCode() {
      if (this.resendCountdown > 0) return;

      await this.requestConfirmEmail();
    },

    startResendCountdown() {
      this.resendCountdown = 60;
      if (this.resendInterval) clearInterval(this.resendInterval);

      this.resendInterval = setInterval(() => {
        if (this.resendCountdown > 0) {
          this.resendCountdown--;
        } else {
          clearInterval(this.resendInterval);
        }
      }, 1000);
    },

    async confirmEmail() {
      if (!this.$refs.form.validate()) return;

      try {
        this.loading.confirmation = true;

        const payload = {
          code: this.form.code,
        };

        await confirmEmail(payload);

        this.$alert("E-mail confirmado com sucesso", "success");
        this.$root.$emit("load-session");

        this.confirmDialog = false;
      } catch (error) {
        this.$alert(error?.message, "error");
      } finally {
        this.loading.confirmation = false;
      }
    },

    changeEmail() {
      this.confirmDialog = false;
      this.$router.push(
        { name: "ChangeEmail" },
        () => {},
        () => {}
      );
    },
  },

  beforeDestroy() {
    if (this.resendInterval) clearInterval(this.resendInterval);
  },
};
</script>

<style lang="scss" src="./style.scss" scoped />
